export default "__VITE_ASSET__ConXWNh1__"